import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, OtherWorkPayRateLookup, OtherWorkPayRateLookupUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateOtherWorkPayRateLookup(): UseMutationResult<
  AxiosResponse<OtherWorkPayRateLookup>,
  AxiosError<ErrorMessage>,
  OtherWorkPayRateLookupUpdate
> {
  const queryClient = useQueryClient();

  const updateOtherWorkPayRateLookup = (
    payload: OtherWorkPayRateLookupUpdate,
  ): Promise<AxiosResponse<OtherWorkPayRateLookup>> => {
    return client.put(`other-work-pay-rate-lookups/${payload?.otherWorkPayRateLookupId}/`, payload);
  };

  return useMutation(updateOtherWorkPayRateLookup, {
    onSuccess: () => {
      queryClient.invalidateQueries(['otherWorkPayRateLookups']);
    },
  });
}
